/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("load", () => {
    // tooltip
    // selecting images
    const images = document.querySelectorAll(
      ".product-single__content .media-gallery__image"
    );
    // selecting tooltips
    const modelInfo = document.querySelectorAll(".media-gallery__tooltip");
    const tooltips = document.querySelectorAll(
      ".media-gallery__slider--tooltip"
    );
    const femaleRadio = document.querySelector("#female");
    const maleRadio = document.querySelector("#male");
    const dots = document.querySelectorAll(".media-gallery .slick-dots li");
    let maleCount = 0;
    let femaleCount = 0;
    let forloopIndex = 0;

    let zoomFemaleCount = 0;
    let zoomMaleCount = 0;
    // end of tooltip
    for (let i = 0; i < images.length; i++) {
      forloopIndex++;
      const imagesAlt = images[i].alt;
      const imagesAltSplit = imagesAlt.split(` - `); // used ft for test purposes
      const rightPart = imagesAltSplit[1];

      if (
        imagesAlt !== "Reach Technical Midlayer" &&
        imagesAlt.includes(" - ")
        // && // left for test purposes
        // (imagesAlt.slice(-1) === "." || imagesAlt.slice(-1) === " ")
      ) {
        // Assuming you have some HTML element where you want to set the text content
        tooltips[i].textContent = rightPart.slice(0, -1); // Set the text content to the right part

        modelInfo[i].style.display = "block";
      }
      modelInfo[i].addEventListener("click", (e) => {
        // Prevent the click event from propagating to document
        e.stopPropagation();

        // Toggle the active class for the tooltip
        tooltips[i].classList.toggle("active");
      });
      // gender sorting
      const slickSlide = images[i].closest(".slick-slide");
      const slickWrapper = images[i].closest(".media-gallery__wrapper");
      const slickWrapperItems = document.querySelectorAll(
        ".media-gallery .media-gallery__wrapper"
      );
      const slickSlides = document.querySelectorAll(
        ".media-gallery .slick-slide"
      );
      if (imagesAlt.slice(-1) == "F") {
        if (slickSlide) {
          slickSlide.setAttribute("data-female", "true");
          slickWrapper.setAttribute("data-female", "true");
          femaleCount++;
        }
      }
      if (imagesAlt.slice(-1) == "M") {
        if (slickSlide) {
          slickSlide.setAttribute("data-male", "true");
          slickWrapper.setAttribute("data-male", "true");
          maleCount++;
        }
      }
      if (imagesAlt.slice(-1) == "F") {
        if (slickWrapper) {
          slickWrapper.setAttribute("data-female", "true");
        }
      }
      if (imagesAlt.slice(-1) == "M") {
        if (slickWrapper) {
          slickWrapper.setAttribute("data-male", "true");
        }
      }

      maleRadio.addEventListener("change", () => {
        femaleRadio.parentElement.style.backgroundColor = "white";
        femaleRadio.parentElement.style.color = "black";
        maleRadio.parentElement.style.backgroundColor = "black";
        maleRadio.parentElement.style.color = "white";

        slickSlides.forEach((slide) => {
          if (slide.hasAttribute("data-female")) {
            slide.style.display = "none";
          } else if (slide.hasAttribute("data-male")) {
            slide.style.display = "block";
          }
        });
        slickWrapperItems.forEach((wrapper) => {
          if (wrapper.hasAttribute("data-female")) {
            wrapper.style.display = "none";
          } else if (wrapper.hasAttribute("data-male")) {
            wrapper.style.display = "block";
          }
        });
      });
      femaleRadio.addEventListener("change", () => {
        maleRadio.parentElement.style.backgroundColor = "white";
        maleRadio.parentElement.style.color = "black";
        femaleRadio.parentElement.style.backgroundColor = "black";
        femaleRadio.parentElement.style.color = "white";

        slickSlides.forEach((slide) => {
          if (slide.hasAttribute("data-male")) {
            slide.style.display = "none";
          } else if (slide.hasAttribute("data-female")) {
            slide.style.display = "block";
          }
        });
        slickWrapperItems.forEach((wrapper) => {
          if (wrapper.hasAttribute("data-male")) {
            wrapper.style.display = "none";
          } else if (wrapper.hasAttribute("data-female")) {
            wrapper.style.display = "block";
          }
        });
      });

      modelInfo[i].addEventListener("change", (e) => {
        // Prevent the click event from propagating to document
        e.stopPropagation();

        // Toggle the active class for the tooltip
        tooltips[i].classList.toggle("active");
      });

      // Add a click event listener to document to close tooltips when clicking outside
      document.addEventListener("click", (e) => {
        // Close the tooltip if the click event target is not modelInfo[i] or the tooltip itself
        if (e.target !== modelInfo[i] && e.target !== tooltips[i]) {
          tooltips[i].classList.remove("active");
        }
      });

      document.querySelector("#male").addEventListener("change", (e) => {
        e.preventDefault();
      });
    }
    if (window.innerWidth < 750) {
      maleRadio.addEventListener("change", () => {
        dots[0].click();
        dots.forEach((dot, indexOne) => {
          if (indexOne <= forloopIndex - femaleCount)
            dot.style.display = "list-item";
          else dot.style.display = "none";
        });
        if (maleRadio.checked) {
          const slider = document.querySelector(".media-gallery__slider");
          slider.addEventListener("touchmove", () => {
            if (
              dots[forloopIndex - femaleCount].classList.contains(
                "slick-active"
              )
            ) {
              dots[0].click();
            }
          });
        }
      });
      femaleRadio.addEventListener("change", () => {
        dots[0].click();
        dots.forEach((dot, indexTwo) => {
          if (indexTwo <= forloopIndex - maleCount)
            dot.style.display = "list-item";
          else dot.style.display = "none";
        });
        if (femaleRadio.checked) {
          const slider = document.querySelector(".media-gallery__slider");
          slider.addEventListener("touchmove", () => {
            if (
              dots[forloopIndex - maleCount].classList.contains("slick-active")
            ) {
              dots[0].click();
            }
          });
        }
      });
    }

    // media gallery zoom
    const galleryZoom = document.querySelector(".media-gallery__zoom");
    const closeBtn = document.querySelector(".media-gallery__zoom button");
    const imageWrappers = document.querySelectorAll(".media-gallery__wrapper");
    const zoomedImages = document.querySelectorAll(
      ".swiper-slide__zoomed--image img"
    );

    zoomedImages.forEach((image, index) => {
      const imageAlt = image.alt;
      if (imageAlt) {
        if (imageAlt.slice(-1) === "F") {
          image.parentElement.parentElement.setAttribute("data-female", "true");
          zoomFemaleCount++;
        }
        if (imageAlt.slice(-1) === "M") {
          image.parentElement.parentElement.setAttribute("data-male", "true");
          zoomMaleCount++;
        }
      }
    });
    console.log(zoomFemaleCount);
    console.log(zoomMaleCount);
    if (zoomFemaleCount == 0 || zoomMaleCount == 0) {
      const mediaGalleryRadio = document.querySelector(".media-gallery__radio");
      mediaGalleryRadio.style.display = "none";
    } else {
      const mediaGalleryRadio = document.querySelector(".media-gallery__radio");
      mediaGalleryRadio.style.display = "flex";
    }

    imageWrappers.forEach((image) => {
      if (window.innerWidth > 751) {
        image.addEventListener("click", () => {
          galleryZoom.classList.add("active");
          setTimeout(() => {
            const zoomedContent = document.querySelector(
              ".media-gallery__zoom .swiper-slide-active"
            );
            console.log(zoomedContent);
            const video = document.querySelectorAll(
              ".media-gallery__zoom video"
            );
            console.log(video);
            video.forEach((video) => {
              video.currentTime = 0.1;
              video.play();
            });
          }, 50);
        });
      }
    });
    const swiperNextButton = document.querySelector(
      ".media-gallery__zoom .swiper-button-next"
    );
    const swiperPrevButton = document.querySelector(
      ".media-gallery__zoom .swiper-button-prev"
    );

    swiperPrevButton.addEventListener("click", () => {
      setTimeout(() => {
        const zoomedContent = document.querySelector(
          ".media-gallery__zoom .swiper-slide-active"
        );
        console.log(zoomedContent);
        const video = document.querySelectorAll(".media-gallery__zoom video");
        console.log(video);
        video.forEach((video) => {
          video.currentTime = 0.1;
          video.play();
        });
      }, 50);
    });

    swiperNextButton.addEventListener("click", () => {
      setTimeout(() => {
        const zoomedContent = document.querySelector(
          ".media-gallery__zoom .swiper-slide-active"
        );
        console.log(zoomedContent);
        const video = document.querySelectorAll(".media-gallery__zoom video");
        console.log(video);
        video.forEach((video) => {
          video.currentTime = 0.1;
          video.play();
        });
      }, 50);
    });
    closeBtn.addEventListener("click", () => {
      galleryZoom.classList.remove("active");
    });

    femaleRadio.addEventListener("change", () => {
      zoomedImages.forEach((image) => {
        const grandparent = image.parentElement.parentElement;
        if (grandparent.hasAttribute("data-male")) {
          grandparent.style.display = "none";
        } else if (grandparent.hasAttribute("data-female")) {
          grandparent.style.display = "flex";
        }
      });
    });

    maleRadio.addEventListener("change", () => {
      zoomedImages.forEach((image) => {
        const grandparent = image.parentElement.parentElement;
        if (grandparent.hasAttribute("data-female")) {
          grandparent.style.display = "none";
        } else if (grandparent.hasAttribute("data-male")) {
          grandparent.style.display = "flex";
        }
      });
    });
  });
});

document.addEventListener('gesturestart', function(e) {
  if(document.body.classList.contains("no-zoom")){
      e.preventDefault();
      document.body.style.zoom = 0.99;
    }
});

document.addEventListener('gesturechange', function(e) {
  if(document.body.classList.contains("no-zoom")){
    e.preventDefault();
    document.body.style.zoom = 0.99;
  }
});

document.addEventListener('gestureend', function(e) {
  if(document.body.classList.contains("no-zoom")){
    e.preventDefault();
    document.body.style.zoom = 0.99;
  }
});

